var needed, wall_count = 1;
function calculate(){
  var paper = {"inches":"18.8976","centimeters":"48","feet":"1.5748","in":"18.8976","cm":"48","ft":"1.5748"};
  var width_cm, is_error = false;
  const vinyl = {"inches":"25.27559","centimeters":"64.2","feet":"2.106299","in":"25.27559","cm":"64.2","ft":"2.106299"};
  const trim = {"inches":"2","centimeters":"5.08","feet":"0.166667","in":"2","cm":"5.08","ft":"0.166667"};
  const conv = {"inches":"2.54","centimeters":"1","feet":"30.48","in":"2.54","cm":"1","ft":"30.48"}
  //Select required wall height
  var h_units = document.getElementById('user-height').parentElement.querySelector("select").value;
  var h_feet = Math.ceil((document.getElementById('user-height').value * conv[h_units] - 0.001) / 30.48)
  var material = document.querySelector('variant-radios').querySelectorAll('input:checked')[0].value;
  document.querySelector('.height-error').classList.add('hidden')
  document.querySelector('.units-error').classList.add('hidden')
  document.querySelector('button[name="add"]').disabled = false;
  if(document.getElementById('user-height').value == 0){
    // Error - no input
    try {
      document.querySelector('.product-form__input.height input:checked').checked = false;
    } catch(e) {}
  } else if(h_feet <= 4){
      // Choose 4 feet variant
    if(document.querySelector('.product-form__input.height input[value="4 feet"]').checked){
    } else {
      document.querySelector('.product-form__input.height input[value="4 feet"]').checked = true;
      document.querySelector('variant-radios').onVariantChange()
    }
  } else if(h_feet > 4 && h_feet <= 15) {
    // Choose variant which matches h_feet
    if(document.querySelector('.product-form__input.height input[value="'+h_feet+' feet"]').checked){
    } else {
      document.querySelector('.product-form__input.height input[value="'+h_feet+' feet"]').checked = true;
      document.querySelector('variant-radios').onVariantChange()
    }
  } else if(h_feet > 30){
    // Error - units clearly wrong
    document.querySelector('.units-error').classList.remove('hidden')
    is_error = true
    document.querySelector('button[name="add"]').disabled = true
  } else {
    // Error - wall too large - contact us
    document.querySelector('.height-error').classList.remove('hidden')
    is_error = true
    document.querySelector('button[name="add"]').disabled = true
  }

  if(document.querySelector('variant-radios').querySelectorAll('input:checked')[0].value.includes('Vinyl')){
    var panelwidth = "25 inches"
    paper = vinyl
  } else {
    var panelwidth = "19 inches"
  }
  var needed = 0; 
  var width_inputs = document.querySelectorAll("input.width-input");
  var width_text = "";
  try{
    if(document.querySelector('.multiple-walls').open){
      var st = 1;
    } else {
      var st = 0;
    }
  }catch(e){var st = 0}
  for(i=st; i<width_inputs.length; i++){
    var width = width_inputs[i].value || 0;
    var units = width_inputs[i].parentElement.querySelector("select").value;
    if(width == 0){
      wall_x = 0;
    } else {
      wall_x = (parseFloat(width) / paper[units]);
      needed += wall_x;
      if(i==st){
        width_text += width + ' ' + units;
      } else {
        width_text += ', ' + width + ' ' + units;
      }
    }
  }
  needed = Math.ceil(needed + (parseFloat(trim['cm'])/paper['cm']))
  document.querySelector('#input-width').value = width_text;
  document.querySelector('#input-height').value = document.getElementById('user-height').value + ' ' + h_units;
  
  var pricereg = parseInt(document.querySelector("s.price-item--regular").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll('From','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','')) / 100;
  var pricesale = parseInt(document.querySelector(".price-item--sale").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll('From','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','')) / 100;
  if(pricereg > pricesale){
    document.querySelector('div.price').classList.add('price--on-sale')
  } else {
    document.querySelector('div.price').classList.remove('price--on-sale')
  }
  
  if(needed > 0 && typeof(document.querySelector('variant-radios .height').querySelectorAll('input:checked')[0]) != 'undefined'){
    document.querySelector("#calc-result").innerText = document.querySelector("#calc-result").attributes.text.value.replace('[Q]',needed).replace('[W]',panelwidth).replace('wide.','wide, and '+document.querySelector('variant-radios .height').querySelectorAll('input:checked')[0].value+' tall.');
    document.querySelector("#calc-result").style.display = 'revert';
    document.querySelector(".quantity__input").value = needed;
    document.querySelector("#our-price").innerText = pre + (needed * parseInt(document.querySelector(".price-item--regular").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','')) / 100).toFixed(2);
    try{document.querySelector("#our-code-price").innerText = pre + (Math.floor((needed * parseFloat(document.querySelector(".price-item--regular").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','') * (100 - document.querySelector("#our-code-price").attributes['discount'].value) / 100))) / 100).toFixed(2);
       }catch(e){}
    document.querySelector("#our-old-price").innerText = pre + (needed * pricereg).toFixed(2);
    document.querySelector("#our-sale-price").innerText = pre + (needed * pricesale).toFixed(2);
    document.querySelector('.col-flex .price:not(.price--large)').classList.remove("hidden");
    document.querySelector('.width-error').classList.add("hidden");  
    document.querySelector('.product-form__submit').disabled = false;
    document.querySelectorAll('.form-right .price').forEach((element) => {element.style.display = 'revert';});
  } else {
    document.querySelector("#calc-result").style.display = 'none';
    try{document.querySelector("#our-price").innerText = document.querySelector(".price-item--regular").innerHTML.replaceAll(' ','').replaceAll('\n','') ;
     }catch(e){}
    document.querySelector("#our-old-price").innerText = pre + pricereg.toFixed(2);
    document.querySelector("#our-sale-price").innerText = pre + pricesale.toFixed(2);
    document.querySelector('.col-flex .price:not(.price--large)').classList.add("hidden");
    document.querySelector('.width-error').classList.remove("hidden");    
    document.querySelector('.product-form__submit').disabled = true;
  }
  if(is_error){
    document.querySelector('button[name="add"]').disabled = true;
    document.querySelector("#calc-result").style.display = 'none';
    document.querySelectorAll('.form-right .price').forEach((element) => {element.style.display = 'none';});
  }
}

function add_wall(remove){
  // old - needs removing
  var walls = document.querySelectorAll('.width-container.walls');
  if(remove == 'remove'){
    var remove = walls[walls.length - 1]
    remove.parentElement.removeChild(remove)
    wall_count = walls.length - 1;
  } else {
    if(wall_count > 5){
      // Too many walls
      return
    }
    var copy = walls[0].parentElement.appendChild(walls[0].cloneNode(true));
    wall_count = walls.length + 1;
    copy.classList.remove('wall-1');
    copy.classList.add('wall-'+wall_count);
    copy.querySelector('#user-width-1').id = 'user-width-'+wall_count;
    copy.querySelector('#user-width-'+wall_count).value = "";
    copy.querySelector('select[name="width_unit-1"]').setAttribute('name','width_unit-'+wall_count);
    for(e=0;e<copy.querySelectorAll('option[name="width_unit-1"]').length; e++){
      var old = copy.querySelectorAll('option[name="width_unit-1"]')[e].id;
      copy.querySelectorAll('option[name="width_unit-1"]')[e].id = old.replace('-1','-'+wall_count);
      copy.querySelectorAll('option[name="width_unit-1"]')[e].setAttribute('name','width_unit-'+wall_count);
    }
    for(l=0;l<copy.querySelectorAll('label').length; l++){
      var old = copy.querySelectorAll('label')[l].getAttribute('for');
      copy.querySelectorAll('label')[l].setAttribute('for',old.replace('-1','-'+wall_count));
    }                  
  }     
  
  if(wall_count > 1){
    document.querySelector("#remove-wall").classList.remove('hidden')
  } else {
    document.querySelector("#remove-wall").classList.add('hidden')
  }
}

var canvas
    , hcanvas = document.createElement('canvas')
    , context;
const custom_img = {}
var imgData_initial = {}
  , output = {}
  , isready = []
  , newcolors = []
  , photocanvases = []
  , upload_file
  , url
  , urlThumb;

if(window.location.href.includes('/products/')){
  canvas = document.querySelector('#design')
  context = canvas.getContext('2d',{ alpha: true , desynchronized: false , colorSpace: 'srgb' , willReadFrequently: true })
}

function customHex(layer,drawer){
  var user_hex = document.querySelectorAll('.hex-layer-'+layer)[drawer].value;
  if(user_hex.charAt(0) !== '#'){user_hex = '#' + user_hex}
  var reg=/^#[0-9A-F]{6}$/i;
  if(reg.test(user_hex)){
    document.querySelectorAll('.hex-layer-'+layer)[drawer].style.border = ""
    layerColor(layer,user_hex)
    //change color name to say hex code
  } else {
    // display error
    document.querySelectorAll('.hex-layer-'+layer)[drawer].style.border = "1px solid red";
  }
}
function hex(hex) {
  var rgb = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return rgb ? {
    r: parseInt(rgb[1], 16),
    g: parseInt(rgb[2], 16),
    b: parseInt(rgb[3], 16)
  } : null;
}
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}
function rgbToHex(r, g, b) {
  return "#" + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

function colorReset(){
  if(layers[0]){
    layerColor('bg',layers[0])
  }
  for(k=1;k<layers.length;k++){
    layerColor(k,layers[k])
    draw();
  }
  updateText(true)
  updateURLParams(true)
}
var load_event_set = false
function updateInputs(layer,text){
  try {
    document.querySelector('#input-layer-'+layer+'-color').value = text;
    document.querySelector('#sample-input-layer-'+layer+'-color').value = text;
    document.querySelector('#sample-input-layer-'+layer+'-color-mobile').value = text;
  } catch(e) {
    if(document.readyState !== 'complete'){
      if(load_event_set == false){
        window.addEventListener('load', updateInputs(layer,text));
        load_event_set = true;
      }
    }
  }
}
function updateDynaBG(){
  if(typeof(document.querySelector('.dynamic-background')) != 'undefined'){
    var dyna_bg_el = document.querySelectorAll('.dynamic-background')
    for(e=0; e<dyna_bg_el.length; e++){
      var el_hex = newcolors[dyna_bg_el[e].attributes['layer'].value] || dyna_bg_el[e].attributes['color'].value;
      dyna_bg_el[e].style = 'background-color:'+el_hex;
      // console.log('Changing paint color to ',hex_library[el_hex],el_hex)
    }
  }
}
function layerColor(layer,newcolor,preload){
    var fmt_newcolor = newcolor.replaceAll(" ","").toLowerCase()
    document.querySelector(".cc-layer-"+ layer +"-swatch").style.background = newcolor;
    var classname = ".cc-mobile-layer"+layer;
    var prevactive = document.querySelectorAll(classname + " .active");
    if(prevactive){
      for(i=0;i<prevactive.length;i++){prevactive[i].classList.remove('active')}
    }
    // console.log(fmt_newcolor)
    var active = document.querySelector(classname + ' div[data="'+fmt_newcolor+'"]');
    if(active){
      // change to use a lookup table?
      active.classList.add('active');
      var text = active.parentElement.children[1].innerHTML;

      document.querySelector('.cc-layer-'+layer+'-color-text').innerText = text;
    } else if((layer == 'bg' && newcolor !== layers[0]) || newcolor !== layers[layer]) {
      document.querySelector('.cc-layer-'+layer+'-color-text').innerText = newcolor;
      var text = newcolor;
    } else {
      document.querySelector('.cc-layer-'+layer+'-color-text').innerText = "";
      var text = "Unchanged";
    }
    if(newcolor == layers[layer]){
      custom_img[layer] = null;
      newcolors[layer] = null;
      draw()
      if(document.querySelector(classname+".open")){
        togglePalette(layer)
      }
      updateInputs(layer,text)
      updateText()
      return
    }
    if(layer == 'bg'){
      newcolors[0] = fmt_newcolor;
      if(preload != true){
        if(img[1].complete){
          draw()          
        } else {
          console.log('img[1]] not complete')
          setTimeout(() => {
            layerColor(layer,newcolor,preload);
          },50)
        }
        draw()
        
      }
      if(document.querySelector(classname+".open")){
        togglePalette('bg')
      }
      updateInputs(layer,text)
      updateText()
      updateDynaBG()
      updateURLParams()
      return
    }
    custom_img[layer] = new Uint8ClampedArray(img_initial[layer].length)
    var new_rgb = hex(fmt_newcolor)
    , init_rgb = hex(layers[layer]);
    for (let i = 0; i < custom_img[layer].length; i += 4) {
        var r = img_initial[layer][i]
        , g = img_initial[layer][i+1]
        , b = img_initial[layer][i+2]
        var over = Math.max(Math.max(255,r - init_rgb.r + new_rgb.r),Math.max(255,g - init_rgb.g + new_rgb.g),Math.max(255,b - init_rgb.b + new_rgb.b)) - 255
        , under = Math.min(Math.min(0,r - init_rgb.r + new_rgb.r),Math.min(0,g - init_rgb.g + new_rgb.g),Math.min(0,b - init_rgb.b + new_rgb.b))
        , x = 1; // used to be 1 - (over/255)
        custom_img[layer][i] = Math.max(Math.min(255,((r - init_rgb.r) + new_rgb.r)*x),0)
        custom_img[layer][i+1] = Math.max(Math.min(255,((g - init_rgb.g) + new_rgb.g)*x),0)
        custom_img[layer][i+2] = Math.max(Math.min(255,((b - init_rgb.b) + new_rgb.b)*x),0)
        custom_img[layer][i+3] = img_initial[layer][i+3];
    }
    newcolors[layer] = fmt_newcolor;
    draw()
    if(document.querySelector(classname+".open")){
      togglePalette(layer);
    }
    updateInputs(layer,text)
    updateText()
    updateDynaBG()
    updateURLParams()
    return
}
function updateText(resetcolors){
    var colors_text = "";
    var textelement = document.querySelector('.cc-color-text')
    if(resetcolors == true){
      var color_desc = document.querySelectorAll('.cc-layer-color-text')
      for(l=0;l<colornames.length;l++){
        color_desc[l].innerText = colornames[l] || hex_library[layers[l]] || '';
      }
      return
    }
    
    if(layers[0] !== null){ var start = 0 } else { var start = 1; }
    for(l=start;l<layers.length;l++){
      if(newcolors[l] == layers[l] || newcolors[l] == null){}else{break}
      if(l == layers.length - 1){
        return
      }
    }
    for(l=start;l<layers.length;l++){
      if(newcolors[l] == layers[l] || newcolors[l] == null){
        colors_text += "Unchanged"
      } else {
        var active = document.querySelector("div[data='"+newcolors[l].replaceAll(" ","")+"']")
        if(active){
          colors_text += active.parentElement.children[1].innerHTML;
        } else {
          colors_text += newcolors[l];
        }
      }
      if(l == layers.length - 1){
        textelement.innerText = colors_text;
      } else {
        colors_text+=", "
      }
    }
  }
var q = 1, downscale = 1;

function put(l){
  if(img_initial[l].length < 1){
    setTimeout(() => {
      draw()
    },50)
  } else {
    var target = eval("outctx_"+l);
    target.clearRect(0,0,target.canvas.width,target.canvas.height);
    if(custom_img[l] != null){
      target.putImageData(new ImageData(custom_img[l],canvas.width,canvas.height),0,0);
    } else {
      target.putImageData(new ImageData(img_initial[l],canvas.width,canvas.height),0,0);
    }
    drawLayer(l);
  }
  return
}

function drawLayer(l){
  context.drawImage(eval("outcan_"+l),0,0)
}

function draw(){
  for(l=1;l<layer_src.length;l++){
    if(!img[l].complete){
      setTimeout(() => {
        draw()
      },50)
      return
    }
  }
  context.clearRect(0,0,canvas.width,canvas.height);
  context.fillStyle = newcolors[0] || layers[0];
  context.fillRect(0,0,canvas.width,canvas.height)
  
  for(l=1;l<layer_src.length;l++){
     put(l);
  }

  canvas.toBlob((blob) => {
    upload_file = new File([blob], "img.png",{type:"image/png", lastModified:new Date().getTime()});
    var prev_url = urlThumb;
    urlThumb = URL.createObjectURL(blob);
    const imgPrev = document.querySelectorAll("div.colors-preview")
    imgPrev.forEach((el) => {
      el.style.backgroundImage = 'url('+urlThumb+')';
    });
    setTimeout(() => {
      URL.revokeObjectURL(prev_url)
    },1000)
  });
}
function cache(){
    for(l=1;l<layer_src.length;l++){
        context.clearRect(0, 0, canvas.width, canvas.height)
        context.drawImage(img[l], 0, 0, canvas.width, canvas.height)
        const original = context.getImageData(0, 0, canvas.width, canvas.height).data
        img_initial[l] = new Uint8ClampedArray(original.length)
        for (let i = 0; i < original.length; i += 1) {
            img_initial[l][i] = original[i]
        }
        imgData_initial[l] = new ImageData(img_initial[l],canvas.width,canvas.height)
    }
}
function findHex(name){
  if(typeof(color_library) == 'undefined'){return false}
  return color_library[name]
}
function findName(hex){
  if(typeof(hex_library) == 'undefined'){return false}
  return hex_library[hex]
}
function toTitleCase(str) {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}
function loadPreselect(){
  if(preselect == null){
    return
  } else {
    var preselect_layers = preselect.split(','), start_num = 0, pre = true;
    var bg_present = document.querySelector('.cc-layer-bg-swatch') || null;
    
    if(bg_present !== null){
      var col = findHex(toTitleCase(preselect_layers[0].replace('%20',' '))) || '#' + preselect_layers[0];
      if(col != '#' && col != 'undefined'){
        if(preselect_layers.length == 1){pre = false;}
        layerColor('bg',col,pre);
        if( (hex(col).r + hex(col).g + hex(col).b) < 382 ){
          document.querySelector('.cc-layer-bg-swatch').children[0].classList.add('light')
        } else {
          document.querySelector('.cc-layer-bg-swatch').children[0].classList.remove('light')
        }
      }
      start_num = 1
    }
    for(var a=start_num; a<preselect_layers.length; a++){
      var col = findHex(toTitleCase(preselect_layers[a].replace('%20',' '))) || '#' + preselect_layers[a];
      if(col != '#' && col != 'undefined'){
        if(a == preselect_layers.length - 1){pre = false;}
        layerColor(a + 1 - start_num,col,pre);
        //change layer text dark/light
        if((hex(col).r + hex(col).g + hex(col).b) < 382 ){
          document.querySelector('.cc-layer-'+ (a + 1 - start_num) +'-swatch').children[0].classList.add('light')
        } else {
          document.querySelector('.cc-layer-'+ (a + 1 - start_num) +'-swatch').children[0].classList.remove('light')
        }
      }
    }
  }
}
function updateURLParams(reset){
  var url_text = ''
  if(reset != true){
    document.querySelectorAll('.cc-layer-color-text').forEach(function (element, index) {
      if(index > 0){url_text += ','}
      url_text += element.innerText.replace('#','');
    })
  }
  var url_params={}, url_preselect = null, href =  window.location.href.split("?")[0];
  if(window.location.href.includes('?')){
    var url_data = window.location.href.split("?")[1].split("&");
    if(url_data != ''){
      for(i=0;i<url_data.length;i++){
        if(reset == true && url_data[i].split('=')[0] == 'layers'){continue}
        url_params[url_data[i].split("=")[0]] = url_data[i].split("=")[1];
      } 
    }
  }
  if(url_text != ''){
    url_params['layers'] = url_text;
  } else {
    delete url_params['layers']
  }

  for( p=0; p<Object.keys(url_params).length; p++){
    var curr_k = Object.keys(url_params)[p]
    if(p == 0){href += '?'}
    if(p > 0){href += '&'}
    href += curr_k + '=' + url_params[curr_k];
  }
  if (window.history.replaceState) {
     window.history.replaceState(null, '', href);
  }
}
function toHSL(hex) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    var r = parseInt(result[1], 16), g = parseInt(result[2], 16), b = parseInt(result[3], 16);
    r /= 255, g /= 255, b /= 255;
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if(max == min){
        h = s = 0; 
    } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max) {
            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
            case g: h = (b - r) / d + 2; break;
            case b: h = (r - g) / d + 4; break;
        }
        h /= 6;
    }
    var hsl = {
      "h": Math.round(360*h),
      "s": Math.round(s*100),
      "l": Math.round(l*100)
    }
    return hsl
}
function ready(){
    for(i=1;i<layer_src.length;i++){
        if(img[i].complete == false){
            return
        } else if(i + 1 == layer_src.length){
            canvas.width = img[1].width;
            canvas.height = img[1].height;
            for(l=1;l<layer_src.length;l++){
              var curr_can = eval("outcan_"+l);
              curr_can.width = img[1].width;
              curr_can.height = img[1].height;
            }
            hcanvas.width = img[1].width / 2;
            hcanvas.height = img[1].height / 2;
            canvas.style.aspectRatio = img[1].width / img[1].height;
            cache();
            loadPreselect();
          return
        }
    }
}
function load(){
    for(i=1;i<layer_src.length;i++){
      if(img[i]){
        if(img[i].complete && i+1 == layer_src.length){
          ready()
        } else {
        img[i].addEventListener('load', () => {
            ready()
        })
        }
      }else{
        img[i] = new Image()
        img[i].crossOrigin = "Anonymous";
        img[i].src = document.getElementById(layer_src[i]).src;
        if(img[i].complete && i+1 == layer_src.length){
          ready()
        } else {
        img[i].addEventListener('load', () => {
            ready()
        })
        }
      }
    }
}
if(window.location.href.includes('/products/')){
  load()
}
function togglePalette(layer){
  if(document.querySelector('.cc-click-me').classList.contains('hidden')){}else{
    for(e=0;e<document.querySelectorAll('.cc-click-me').length;e++){
      document.querySelectorAll('.cc-click-me')[e].classList.add('hidden')
    }
  }
  
  if(false){
    var open = document.querySelectorAll('.cc-layer-palette.open');
    var arrows = document.querySelectorAll('.cc-palettes-arrow.open');
    var target = document.querySelector('.cc-layer-'+layer+'-palettes');
    var arrowtarget = document.querySelector('.arrow-'+layer);
  } else {
    var open = document.querySelectorAll('.cc-palette-drawer.open');
    var target = document.querySelector('.cc-mobile-layer'+layer);
  }
   
  if(open){
    for(i=0;i<open.length;i++){
      open[i].classList.remove('open')
      if(arrows){
        arrows[i].classList.remove('open')
        arrows[i].parentElement.parentElement.classList.remove('open')
      }
    }
  }
  if(open[0] == target){
    target.classList.remove('open')
    if(arrowtarget){
      arrowtarget.classList.remove('open')
      arrowtarget.parentElement.parentElement.classList.remove('open')
    }
  } else {
    target.classList.add('open')
    if(arrowtarget){
      arrowtarget.classList.add('open')
      arrowtarget.parentElement.parentElement.classList.add('open')
    }
  }
}

var orig_height_val, radios
function sample(){
    radios = document.querySelectorAll('variant-radios input:checked')
    var quantity = document.querySelector('.quantity__input')
    var paper = document.querySelector('.cc-sample-option input[type=radio]:checked');
    try{
      orig_height_val = radios[1].value;
      document.querySelector('variant-radios input[value="'+paper.value+'"]').checked = true;
      document.querySelector('variant-radios input[value="Sample"]').checked = true;
      quantity.value = 1;
      // document.querySelector('#user-width').value = "";
      document.querySelector('variant-radios').onVariantChange()
      var event = new Event('click');
      document.querySelector('product-form').onSubmitHandler(event);
      document.querySelector('.cc-sample-error').style.display = ''
    } catch(e) {
      document.querySelector('.cc-sample-error').style.display = 'unset'
    }
}
function sampleToCart(event){
  event.preventDefault();
  const sample_button = event.target.closest('form').querySelector('.button__sample-add-to-cart')
  
  if (sample_button.getAttribute('aria-disabled') === 'true') return;
  document.querySelector('.cc-sample-error').classList.add('hidden')
  // this.handleErrorMessage();
  if(document.querySelector('fieldset[name=id] input:checked') == null){
    document.querySelector('.cc-sample-error').classList.remove('hidden');
    return
  }
  
  sample_button.setAttribute('aria-disabled', true);
  sample_button.classList.add('loading');
  sample_button.querySelector('.loading-overlay__spinner').classList.remove('hidden');
  
  const config = fetchConfig('javascript');
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(event.target.form);
  if(typeof(upload_file) !== 'undefined'){
    formData.append('properties[Your ' + color_spelling + 's]', upload_file, 'image.png');
  }
  if (cart) {
    formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
    formData.append('sections_url', window.location.pathname);
    cart.setActiveElement(document.activeElement);
  }
  config.body = formData;
  window.dataLayer = window.dataLayer || [];                                            
  window.dataLayer.push({
    'page_type': 'product',
    'event': 'addtocart',
    'currency': Shopify.currency.active,
    'transactionTotal': (document.querySelector('.quantity__input').value * parseInt(document.querySelector(".price-item--sale").innerHTML.replaceAll(' ','').replaceAll('\n','').replaceAll(pre,'').replaceAll('.','').replaceAll(',','')) / 100).toFixed(2),
    'productID': productID,
  });
  
  fetch(`${routes.cart_add_url}`, config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        // this.handleErrorMessage(response.description);
        
        const soldOutMessage = sample_button.querySelector('.sold-out-message');
        if (!soldOutMessage) return;
        sample_button.setAttribute('aria-disabled', true);
        sample_button.querySelector('span').classList.add('hidden');
        soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      } else if (!cart) {
        window.location = window.routes.cart_url;
        return;
      }

      this.error = false;
      const quickAddModal = null; //this.closest('quick-add-modal');
      if (quickAddModal) {
        document.body.addEventListener('modalClosed', () => {
          setTimeout(() => { cart.renderContents(response) });
        }, { once: true });
        quickAddModal.hide(true);
      } else {
        cart.renderContents(response);
      }
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      sample_button.classList.remove('loading');
      if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      if (!this.error) {
        sample_button.removeAttribute('aria-disabled');
      }

      sample_button.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
}



// Search by Color Functions
var chosen = [];
function searchByURL(){
  if(window.location.href.includes('?')){
    loadLayers();
    var ex_params={}, url_preselect = null;
    var ex_data = window.location.href.split("?")[1].split("&");
    for(var i=0;i<ex_data.length;i++){
      ex_params[ex_data[i].split("=")[0]] = ex_data[i].split("=")[1];
    }
    if(typeof(ex_params['searchby']) != 'undefined'){
      var cnames = ex_params['searchby'].replaceAll('%20',' ').split(',');
      for(var n=0; n<cnames.length; n++){
        searchColor(n,color_library[cnames[n]],n==cnames.length-1)
        if(n>7){alert('Too many '+color_spelling+'s - extra '+color_spelling+'s will be omitted.');break}
      }
      document.querySelector('.searchbycolor').open = true
      try{
        showHideScene(null,'Pattern') // change to pattern view
        document.querySelectorAll('div.scene-switch__container').forEach(cont => cont.classList.add('disabled')) // disable scene view
       }catch(e){}
    }
  }
  return
}
function clearSearch() {
  try{
    document.querySelectorAll('div.scene-switch__container').forEach(cont => cont.classList.remove('disabled')) // disable scene view
   }catch(e){}
  for(var i=0; i<8; i++){
    document.querySelector(".cc-layer-"+ i +"-swatch").style.background = 'white';
    var act = document.querySelector(".cc-mobile-layer"  +i + " .active") || null;
    if(act){act.classList.remove('active')}
    if(i>1){document.querySelector(".cc-layer-"+ i +"-swatch").parentElement.classList.add('hidden')}
    document.querySelector('.cc-layer-'+i+'-color-text').innerText = 'Empty';
    document.querySelector('.cc-layer-'+i+'-swatch .cc-click-me').classList.remove('hidden')
  }
  chosen = [];
  // update URL
  if(window.location.href.includes('?')){
      var ex_params={}, url_preselect = null;
      var ex_data = window.location.href.split("?")[1].split("&");
      if(ex_data != ''){
        for(var i=0;i<ex_data.length;i++){
          ex_params[ex_data[i].split("=")[0]] = ex_data[i].split("=")[1];
        }
        if(typeof(ex_params['searchby'])){
          delete ex_params['searchby']
        }
        var new_href = '';
        for(var p=0; p<Object.keys(ex_params).length; p++){
          var curr_k = Object.keys(ex_params)[p]
          if(p > 0){new_href += '&'}
          new_href += curr_k + '=' + ex_params[curr_k];
        }
      } else { var new_href = '';}
    } else {
      var new_href = '';
    }
    if(new_href == ''){
      window.history.replaceState({ }, '', `${window.location.href.split('?')[0]}`);
    } else {
      window.history.replaceState({ }, '', `${window.location.href.split('?')[0]}?${new_href}`);
    }

    // update products
    // for each product
    var prods = document.querySelectorAll("dynamic-product")
    for(p=0;p<prods.length;p++){
      lays = prods[p].querySelectorAll("layer");
      // for each layer
      for(var l=0;l<lays.length; l++){
        if(lays[l].children[0].nodeName == 'BG'){
          lays[l].querySelector('bg').style = "background:"+lays[l].querySelector('bg').attributes.color.value;
        } else if(lays[l].attributes.color.value == 'No Color'){
          continue
        } else {
          try{lays[l].querySelector('.preview-layer').src = '';} catch(e) {}
        }
      }
      // reset url
      prods[p].closest('div.card-wrapper').querySelector("a.full-unstyled-link").href = prods[p].closest('div.card-wrapper').querySelector("a").attributes.productlink.value;
      // reset chips
      var chips = prods[p].closest('div.card-wrapper').querySelectorAll("color-chip");
      for(var ch = 0; ch < chips.length; ch++){
        chips[ch].style = 'background:'+chips[ch].attributes.color.value;
        chips[ch].alt = color_library[chips[ch].attributes.color.value] || chips[ch].attributes.color.value;
      }
    }
}
function searchColor(idx,newcolor,islast){
    
    var fmt_newcolor = newcolor.replaceAll(" ","").toLowerCase()
    document.querySelector(".cc-layer-"+ idx +"-swatch").style.background = newcolor;
    var classname = ".cc-mobile-layer"+idx;
    
    var prevactive = document.querySelectorAll(classname + " .active") || null;
    if(prevactive){
      for(i=0;i<prevactive.length;i++){prevactive[i].classList.remove('active')}
    }
    var active = document.querySelector(classname + ' div[data="'+fmt_newcolor+'"]');
    if(active){
      active.classList.add('active');
      var text = active.parentElement.children[1].innerHTML;
      document.querySelector('.cc-layer-'+idx+'-color-text').innerText = text;
    } 

    if(document.querySelector('.cc-layer-'+idx+'-color-text').parentElement.classList.contains('hidden')){
      document.querySelector('.cc-layer-'+idx+'-color-text').parentElement.classList.remove('hidden')
    }
    
    chosen[idx] = fmt_newcolor;
    
    if(document.querySelector(classname+".open")){
      togglePalette(idx)
    }    
    
    if(islast){changeProducts();}
    
    return
}
function compareHexes(hex0,hex1){
  if(typeof(hex0) == 'undefined' || typeof(hex1) == 'undefined'){ return 1000 }
  var rgb0 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex0);
  var r0 = parseInt(rgb0[1], 16), g0 = parseInt(rgb0[2], 16), b0 = parseInt(rgb0[3], 16);
  var rgb1 = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex1);
  var r1 = parseInt(rgb1[1], 16), g1 = parseInt(rgb1[2], 16), b1 = parseInt(rgb1[3], 16);
  var variance = Math.abs(r0 - r1) + Math.abs(g0 - g1) + Math.abs(b0 - b1);
  return variance
}

function changeProducts(){
  try{
    showHideScene(null,'Pattern') // change to pattern view
    document.querySelectorAll('div.scene-switch__container').forEach(cont => cont.classList.add('disabled')) // disable scene view
   }catch(e){}
  
  // remove duplicate of BG
  for(var ch=1; ch<chosen.length; ch++){
    if(chosen[ch] == chosen[0]){
      delete chosen[ch]
      chosen = chosen.filter(col => col !== null)
    }
  }
  
  var prods = document.querySelectorAll("dynamic-product")
  for(p=0;p<prods.length;p++){
    var output=[];
    var inp=[], lays = prods[p].querySelectorAll("layer"), cols=[], i_cols=[];
    var selected_inp, selected_lay, start_l0 = 0;

    Object.assign(inp, chosen)

    for(l0=0;l0<lays.length;l0++){
      if(lays[l0].attributes.color.value !== "No Color"){
        i_cols.push(lays[l0].attributes.color.value);
        cols.push(lays[l0].attributes.color.value);
      }
    }

    if(lays[0].attributes.layer.value == 'bg' && lays[0].attributes.color.value !== "No Color"){
      output[0] = inp[0];
      i_cols.push(lays[0].attributes.color.value);
      start_l0 = 1;
      delete cols[0];
      delete inp[0];
    }

    if(lays[0].attributes.layer.value == 1){
      output[0] = inp[0];
      i_cols.push(lays[0].attributes.color.value);
      start_l0 = 1;
      delete cols[0];
      delete inp[0];
    }
    
    if(chosen.length < 1){alert('Please pick some colors to continue.'); return}
    if(lays.length == 1){
      // 1 color input
    } else if (lays.length == 2 && chosen.length == 2){
      if(lays[1].attributes.color.value !== "No Color"){
        // 2 color design, 2 color input
        output[1] = inp[1];
        start_l0 = 2;
        i_cols.push(lays[1].attributes.color.value);
        delete cols[1];
        delete inp[1];
      }
    } else {
      // more than 2 colors, match chosen colors to layers
      start_l0 = 1;
      if(start_l0 < lays.length){
        for(l=start_l0;l<lays.length;l++){
          var v, v0=1000
          var selected_lay = null, selected_inp = null
          for(i=0;i<inp.length;i++){
            if(typeof(inp[i]) == 'undefined'){ continue }
            for(x=0;x<cols.length;x++){
              if(typeof(cols[x]) == 'undefined'){ continue }
              v = compareHexes(cols[x],inp[i]);
              if(v < v0){
                v0 = v;
                selected_inp = i;
                selected_lay = x;
              }
            }
          }
          if(selected_inp == null || selected_lay == null){ continue }
          
          // save and remove selected pair before looping
          output[selected_lay] = inp[selected_inp];
          delete cols[selected_lay];
          delete inp[selected_inp];
        }
      }
      if(lays.length > chosen.length){
        // more layers than colors, deal with unmatched layers
        if(lays[0].attributes.layer.value == 1){var z=0, y=0;} else {var z=1, y=1;}
        var target_layer
        for(z; z<lays.length; z++){
          if(typeof(output[z]) != 'undefined'){
            target_layer = z;
            break
          }
        }
        if(typeof(target_layer) == 'undefined' && chosen.length == 1){target_layer=0;} // if no changed layers use bg
        // apply same transformation to other layers
        for(y; y<lays.length; y++){
          if(typeof(output[y]) == 'undefined' && lays[y].attributes.color.value != 'No Color'){
            var colorname = transformColor(lays[target_layer].attributes.color.value,output[target_layer],lays[y].attributes.color.value)
            output[y] = color_library[colorname];
          }
        }
      }
    }

    var f_col = collectionImage(p,prods[p],i_cols,output)
    
    var urlp = "?layers=";
    var text = "";
    for(o=0;o<output.length;o++){
      text += hex_library[output[o]];
      urlp += hex_library[output[o]];
      if(o < output.length - 1){
        text += ', ';
        urlp += ',';
      }
    }
    var alinks = prods[p].closest('div.card-wrapper').querySelectorAll("a.full-unstyled-link")
    for(var al=0; al<alinks.length; al++){
      alinks[al].href = prods[p].closest('div.card-wrapper').querySelector("a").attributes.productlink.value + urlp;
    }
    var chips = prods[p].closest('div.card-wrapper').querySelectorAll("color-chip")
    for(var ch = 0; ch < chips.length; ch++){
      chips[ch].style = 'background:'+output[ch];
      chips[ch].alt = color_library[output[ch]] || output[ch];
    }
  }

  if(window.location.href.includes('?')){
    var ex_params={}, url_preselect = null;
    var ex_data = window.location.href.split("?")[1].split("&");
    for(var i=0;i<ex_data.length;i++){
      ex_params[ex_data[i].split("=")[0]] = ex_data[i].split("=")[1];
    }
    ex_params['searchby'] = '';
    for(var c=0; c<chosen.length; c++){
      if(c>0){ex_params['searchby'] += ','};
      ex_params['searchby'] += hex_library[chosen[c]] || '';
    }
    var new_href = '';
    for(var p=0; p<Object.keys(ex_params).length; p++){
      var curr_k = Object.keys(ex_params)[p]
      if(p > 0){new_href += '&'}
      new_href += curr_k + '=' + ex_params[curr_k];
    }
  } else {
    var new_href = 'searchby=';
    for(var c=0; c<chosen.length; c++){
      if(c>0){new_href += ','};
      new_href += hex_library[chosen[c]] || '';
    }
  }
  
  window.history.replaceState({ }, '', `${window.location.href.split('?')[0]}?${new_href}`);
     
  var link_page
  let pag_links = document.querySelectorAll('nav.pagination a');
  if(pag_links.length > 0){
    let curr_page = parseInt(document.querySelector('nav.pagination a[aria-current="page"]').attributes['aria-label'].value.replace('Page ',''))
    for(var l=0; l<pag_links.length;l++){
      var arialabel = pag_links[l].attributes['aria-label'].value
      if(arialabel.includes('Next')){
        link_page = curr_page + 1;
      } else if(arialabel.includes('Prev')){
        link_page = curr_page - 1;
      } else {
        link_page = parseInt(arialabel.replace('Page ',''))
      }
      pag_links[l].href = pag_links[l].href.split('?')[0] + '?' + new_href + '&page=' + link_page;
    }
  }
}

var col_url = {}, id_canvas = document.createElement('canvas'), id_context = id_canvas.getContext("2d", { willReadFrequently: true });
function collectionImage(product_index,product_obj,i_col,f_col){
  var start_num = 0, bg = null, id_initial = [], custom_col_img =[];
  var lays = product_obj.querySelectorAll("layer"), unmatched=[];
  col_url[product_index] = [];
  bg_lay = product_obj.querySelector('layer[layer="bg"]') || null;
  if(bg_lay !== null){
    // background layer present
    if(bg_lay.attributes.color.value == 'No Color'){
      // console.log('no color');
    } else if(typeof(f_col[0]) == 'undefined' ){
      // unmatched.push(0);
    }
    bg_lay.querySelector('bg').style = "background-color:"+f_col[0];
    start_num = 1;
    if(lays.length == 1){
      return
    }
  }
  for(let l=start_num;l<lays.length;l++){
    if(lays[l].attributes.color.value == 'No Color'){
      // console.log('no color')
    } else if(typeof(f_col[l]) == 'undefined' ){
      // console.log('found rogue unmatched layer...')
    } else {
      // convert original color
      var img = lays[l].querySelector('.original-layer');
      
      if(!img.complete){
        img.onload = function (){
          collectionImage(product_index,product_obj,i_col,f_col)
        }
        img.loading = '';
        return
      }
      id_canvas.width = img.naturalWidth * window.devicePixelRatio;
      id_canvas.height = img.naturalHeight * window.devicePixelRatio;
      
      id_context.drawImage(img, 0, 0, id_canvas.width, id_canvas.height);
      id_initial[l] = id_context.getImageData(0, 0, id_canvas.width, id_canvas.height).data;
      
      // change layer color and draw
      custom_col_img[l] = new Uint8ClampedArray(id_initial[l].length)
      var new_rgb = hex(f_col[l])
      , init_rgb = hex(i_col[l])
      for (let i = 0; i < custom_col_img[l].length; i += 4) {
          var r = id_initial[l][i]
          , g = id_initial[l][i+1]
          , b = id_initial[l][i+2]
          
          custom_col_img[l][i] = Math.max(Math.min(255,((r - init_rgb.r) + new_rgb.r)),0)
          custom_col_img[l][i+1] = Math.max(Math.min(255,((g - init_rgb.g) + new_rgb.g)),0)
          custom_col_img[l][i+2] = Math.max(Math.min(255,((b - init_rgb.b) + new_rgb.b)),0)
          custom_col_img[l][i+3] = id_initial[l][i+3];
      }
      id_context.putImageData(new ImageData(custom_col_img[l],id_canvas.width,id_canvas.height),0,0);
      
      //output to image
      id_canvas.toBlob((blob) => {
        URL.revokeObjectURL(col_url[product_index][l]);
        col_url[product_index][l] = URL.createObjectURL(blob);
        try{
        lays[l].querySelector('.preview-layer').src = col_url[product_index][l];
        } catch(e) {
          loadLayers()
          lays[l].querySelector('.preview-layer').src = col_url[product_index][l];
        }
      });
    }
  }
  
  return f_col
}
function transformColor(inp,out,target){
  // calculate rgb transform from inp to out 
  // console.log('inp = ',inp,'out = ',out)
  if( typeof(inp) == 'undefined' || typeof(out) == 'undefined' ){ console.log('Not enough data'); inp = inp || out; out = out || inp; }

    var inp_hsl = toHSL(inp)
        , out_hsl = toHSL(out);
    var transf = {"h":(out_hsl.h - inp_hsl.h),"s":(out_hsl.s - inp_hsl.s),"l":(out_hsl.l - inp_hsl.l)};
  // apply same HS transform to target to get output_hex
    target_hsl = toHSL(target);
    new_hsl = {
      "h" : Math.max(0,Math.min(255,target_hsl.h + transf.h)),
      "s" : Math.max(0,Math.min(255,target_hsl.s + transf.s)),
      "l" : target_hsl.l
    }
    var v=1000, res;
    for(name in color_library){
      var test_hsl = toHSL(color_library[name])
        , test_v = Math.abs((new_hsl.h - test_hsl.h) + Math.abs(new_hsl.s - test_hsl.s));
      if(test_v < v){
        res = name;
        v = test_v;
      }
    }
  return res
}

function loadLayers(){
  document.querySelectorAll("loadimg").forEach( element => {
    var newimg = document.createElement("img");
    [...element.attributes].forEach( attr => { newimg.setAttribute(attr.nodeName ,attr.nodeValue) })
    element.replaceWith(newimg);
  })
  document.querySelectorAll("previewimg").forEach( element => {
    var newimg = document.createElement("img");
    [...element.attributes].forEach( attr => { newimg.setAttribute(attr.nodeName ,attr.nodeValue) })
    element.replaceWith(newimg);
  })
}

draw();